module.exports = __webpack_public_path__ + "static/media/whatsapp_guide_desktop_04.ba6cb371.svg";